import type { BiomeKind } from '../generated/BiomeKind';
import { biomeLabel } from './biomeLabel';
import styles from './claimTooltip.module.css';

export interface ClaimTooltipData {
  name: string;
  ownerName: string;
  status: 'Active' | 'Hibernated' | 'Reserved';
  tileCount: number;
  biome: BiomeKind | null;
  isOwn: boolean;
  visibility: 'Public' | 'FriendsOnly' | 'Private' | null;
}

const STATUS_COLORS: Record<string, string> = {
  Active: '#57F287',
  Hibernated: '#FEE75C',
  Reserved: '#949ba4',
};

function formatTileCount(count: number): string {
  if (count >= 1000) return `${Math.round(count / 1000)}K tiles`;
  return `${count} tiles`;
}

export function ClaimTooltip({
  data,
  x,
  y,
}: {
  data: ClaimTooltipData;
  x: number;
  y: number;
}): JSX.Element {
  const dotColor = STATUS_COLORS[data.status] ?? '#949ba4';

  return (
    <div
      className={`${styles.tooltip} ${data.isOwn ? styles.tooltipOwn : styles.tooltipOther}`}
      style={{ left: x, top: y }}
    >
      <div className={styles.header}>
        <div className={styles.statusDot} style={{ background: dotColor }} />
        <span className={styles.name}>{data.name}</span>
        <span className={styles.owner}>{data.ownerName}</span>
      </div>
      <div className={styles.details}>
        {data.biome != null && (
          <>
            <span>{biomeLabel(data.biome)}</span>
            <span className={styles.sep}>&middot;</span>
          </>
        )}
        <span>{formatTileCount(data.tileCount)}</span>
        <span className={styles.sep}>&middot;</span>
        <span style={{ color: dotColor }}>{data.status}</span>
      </div>
      {data.isOwn && data.visibility && (
        <div className={styles.visibilityLine}>{data.visibility}</div>
      )}
    </div>
  );
}
